<script setup lang="ts">
const {size = 30} = defineProps<{
    size: number
}>();
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg" width="41" height="41" viewBox="0 0 41 41" :style="{
      width: `${size}px`,
      height: `${size}px`
    }"
  >
    <g id="thumbnail_video_default_2" transform="translate(4128 3476)">
      <rect
        id="Rectangle_2961" data-name="Rectangle 2961" width="41" height="41"
        transform="translate(-4087 -3476) rotate(90)" fill="#FB0129"
      />
      <g id="Groupe_3588" data-name="Groupe 3588" transform="translate(-4117.487 -3466.935)">
        <path
          id="Icon_awesome-play" data-name="Icon awesome-play"
          d="M15.9,8.045,2.712.248A1.788,1.788,0,0,0,0,1.8V17.384a1.8,1.8,0,0,0,2.712,1.547L15.9,11.139A1.8,1.8,0,0,0,15.9,8.045Z"
          transform="translate(2.744 1.991)" fill="#fff"
        />
      </g>
    </g>
  </svg>
</template>

<style scoped>

</style>
